const transitionEnd = (function() {

    var transitions = {
        "transition"      : "transitionend",
        "OTransition"     : "oTransitionEnd",
        "MozTransition"   : "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
    };

    var fakeEl = document.createElement('div');

    for(var t in transitions) {
        if(fakeEl.style[t] !== undefined) {
            return transitions[t]
        }
    }

    return null;
})();

export default transitionEnd;